export const SIMPLE_V2_BACKEND_EVENT_NAME = {
  incomeDerived: 'simple_income_derived',
  dtiCalculated: 'simple_dti_calculated',
  applicationApproved: 'simple_application_approved',
  applicationManualReview: 'simple_application_manual_review',
} as const

export type SimpleV2BackendEventName =
  (typeof SIMPLE_V2_BACKEND_EVENT_NAME)[keyof typeof SIMPLE_V2_BACKEND_EVENT_NAME]

export const SIMPLE_V2_REASON_CODE = {
  multiBorrower: 'multi_borrower',
  noAddress: 'no_address',
  nonW2Primary: 'non_w2_primary',
  plaidOptOut: 'plaid_opt_out',
  plaidFail: 'plaid_fail',
  plaidAbandon: 'plaid_abandon',
  incomeConfidenceLow: 'income_confidence_low',
  dtiUnviable: 'dti_unviable',
  noViableProducts: 'no_viable_products',
  creditFrozen: 'credit_frozen',
  simplev2Abandonment: 'simplev2_abandonment',
} as const

export type SimpleV2ReasonCode =
  (typeof SIMPLE_V2_REASON_CODE)[keyof typeof SIMPLE_V2_REASON_CODE]

export const SIMPLE_V2_REASON_CATEGORY = {
  eligibility: 'eligibility',
  userBehavior: 'user_behavior',
  data: 'data',
} as const

export type SimpleV2ReasonCategory =
  (typeof SIMPLE_V2_REASON_CATEGORY)[keyof typeof SIMPLE_V2_REASON_CATEGORY]

export const SIMPLE_V2_PLAID_EXIT_OUTCOME = {
  exited: 'plaid_exited',
  fail: 'plaid_fail',
} as const

export type SimpleV2PlaidExitOutcome =
  (typeof SIMPLE_V2_PLAID_EXIT_OUTCOME)[keyof typeof SIMPLE_V2_PLAID_EXIT_OUTCOME]

// Maps each backend event name to its Make schema identifier.
// UI events are routed through Tagular (not Make) so only backend events are listed here.
export const SIMPLE_V2_MAKE_EVENT_TYPE: Record<
  SimpleV2BackendEventName,
  string
> = {
  [SIMPLE_V2_BACKEND_EVENT_NAME.incomeDerived]: 'sage.SimpleV2IncomeDerived.v1',
  [SIMPLE_V2_BACKEND_EVENT_NAME.dtiCalculated]: 'sage.SimpleV2DtiCalculated.v1',
  [SIMPLE_V2_BACKEND_EVENT_NAME.applicationApproved]:
    'sage.SimpleV2ApplicationApproved.v1',
  [SIMPLE_V2_BACKEND_EVENT_NAME.applicationManualReview]:
    'sage.SimpleV2ApplicationManualReview.v1',
}

export const SIMPLE_V2_OFFRAMP_BANNER_CONTENT: Record<
  SimpleV2ReasonCode,
  string
> = {
  multi_borrower:
    'This file was not eligible for Simple V2 because it includes a coborrower. Proceed as usual.',
  no_address:
    'Address report failed or address was missing. Confirm address with client, then proceed as usual.',
  non_w2_primary: 'Non-W2 income selected. Proceed as usual.',
  plaid_opt_out:
    'Borrower opted out of Plaid. Link Account Task is still available in Borrower Portal or collect manual documents.',
  plaid_fail:
    'Plaid failed despite borrower attempting to connect. Link Accounts Task is available in Borrower Portal or collect manual documentation.',
  plaid_abandon:
    'Borrower started Plaid connection but did not complete the flow. Link Accounts Task is available in Borrower Portal or collect manual documentation.',
  income_confidence_low:
    'Patrick could not reliably calculate income from bank transaction data. Collect manual documentation.',
  dti_unviable:
    'Debt-to-income ratio exceeds guidelines. Restructure loan to proceed.',
  no_viable_products:
    'No valid pricing results were found. Restructure loan to proceed.',
  credit_frozen:
    'Credit is frozen. Advise Client to release credit freeze, then proceed as usual.',
  simplev2_abandonment:
    'Borrower left the SIMPLE V2 flow — session timed out or browser was closed before completing the application.',
}
